const { isEmpty } = require("lodash");

const INWARD_CODE_LENGTH = 3;
const OUTWARD_CODE_LENGTH = 4;
const UK_POST_CODE_FULL = /^(GIR[ ]?0AA)|([a-zA-Z]{1,2}(([0-9]{1,2})|([0-9][a-zA-Z]))[ ]?[0-9][a-zA-Z]{2})$/;

const preparePostcode = postcode => {
  const outwardCode = postcode
    .slice(0, postcode.length - INWARD_CODE_LENGTH)
    .padEnd(OUTWARD_CODE_LENGTH, " ");
  const inwardCode = postcode.slice(-INWARD_CODE_LENGTH);

  return {
    inwardCode,
    outwardCode,
  };
};

const getSectors = postcode => {
  const outer = postcode.slice(0, postcode.length - INWARD_CODE_LENGTH).trim();
  const inwardCode = postcode.slice(-INWARD_CODE_LENGTH);

  return {
    outer,
    sector: inwardCode[0],
    inwardCode,
  };
};

const getBusOuterCodeSector = (businessUnit, postcode) => {
  const { outer, sector } = getSectors(postcode);
  return `${businessUnit}^${outer}^${sector}`;
};

const getPostcodeSector = postcode => {
  const { outwardCode, inwardCode } = preparePostcode(postcode);

  return `${outwardCode}${inwardCode[0]}`.toUpperCase();
};

const formatPostcode = postcode => {
  if (!new RegExp(UK_POST_CODE_FULL).test(postcode)) {
    return postcode;
  }

  const withoutSpace = upperPostcodeWithoutSpace(postcode);
  const endPartOfPostcode = withoutSpace.slice(withoutSpace.length - 3);

  return `${withoutSpace.replace(endPartOfPostcode, "")} ${endPartOfPostcode}`;
};

const generateRegexForBIC7PostCodePattern = (bic7PostCodePattern = "") => {
  let regex = "";

  regex += "^"; // Match start of line
  for (let i = 0; i < bic7PostCodePattern.length; i++) {
    /*
     For each character class in the pattern, generate a regex snippet. Wrap each snippet in a grouping for
     completeness.
     */
    if (
      bic7PostCodePattern.charAt(i) === "A" ||
      bic7PostCodePattern.charAt(i) === "B"
    )
      regex += "([A-Z])";
    if (
      bic7PostCodePattern.charAt(i) === "N" ||
      bic7PostCodePattern.charAt(i) === "O"
    )
      regex += "([0-9])";
    if (
      bic7PostCodePattern.charAt(i) === "?" ||
      bic7PostCodePattern.charAt(i) === "X"
    )
      regex += "([A-Z])([0-9])";
  }
  regex += "$"; // Match end of line

  return regex;
};

const upperPostcodeWithoutSpace = postcode =>
  postcode.toUpperCase().replace(/\s/g, "");

// https://it.dpduk.live/version/customer-collections/sprint-3.2/diag_ylfT8W6C48kIGCoJ.html?id=1624618766991
const formatIrishPostcode = postcode => {
  if (isEmpty(postcode)) {
    return postcode;
  }
  let formattedPostcode = upperPostcodeWithoutSpace(postcode);

  if (formattedPostcode.match(/^[zZ]{2}(71|75)$/)) {
    formattedPostcode = `${formattedPostcode}0`;
  } else if (formattedPostcode.match(/^[zZ]{2}(71|75)([ ]?0[aA]{2})?$/)) {
    formattedPostcode = formattedPostcode.substring(
      0,
      formattedPostcode.length - 2
    );
  } else if (formattedPostcode.match(/^D\d$/)) {
    formattedPostcode = "ZZ710";
  } else {
    formattedPostcode = "";
  }
  return formattedPostcode;
};

const deriveOuterCodeSectorFromPostcode = postcode => {
  const formattedPostcode = upperPostcodeWithoutSpace(postcode);

  if (formattedPostcode.match(UK_POST_CODE_FULL)) {
    return formattedPostcode.substring(0, formattedPostcode.length - 2);
  }

  return formattedPostcode;
};

const convertPostcodeToASCII = postcode => {
  let asciiPostcode = "";

  if (postcode !== "") {
    for (let i = 0; i < postcode.length; i++) {
      if (postcode[i].match(/[A-Z]/)) {
        asciiPostcode += postcode.charCodeAt(i).toString();
      } else {
        asciiPostcode += postcode[i];
      }
    }
  } else {
    asciiPostcode = -1;
  }
  return asciiPostcode;
};

module.exports = {
  getPostcodeSector,
  convertPostcodeToASCII,
  deriveOuterCodeSectorFromPostcode,
  formatIrishPostcode,
  formatPostcode,
  preparePostcode,
  getSectors,
  getBusOuterCodeSector,
  generateRegexForBIC7PostCodePattern,
  upperPostcodeWithoutSpace,
};
